module.exports = __webpack_public_path__ + "img/icon-warning.09bec076.svg";